export default __webpack_public_path__ + "static/media/36.c3e558e1.png";